const comments = [
  {
    name: '漫画迷小王',
    avatar: '王',
    rating: 5,
    time: '3天前',
    content: '虫虫动漫真的是我用过最好用的免费漫画平台！下拉式浏览太爽了，不用一直点翻页，而且漫画资源超全，连一些冷门的老番都能找到。画质清晰加载也快，强烈推荐给所有爱看漫画的朋友！',
    tag: '忠实用户',
  },
  {
    name: '二次元少女',
    avatar: '二',
    rating: 5,
    time: '1周前',
    content: '作为一个追了几十部漫画的老读者，虫虫动漫的更新速度让我惊喜。日漫基本和日本同步，国漫也更新很快。最重要的是完全免费！不用充会员就能看全集，真的太良心了。',
    tag: '资深读者',
  },
  {
    name: '深夜追漫人',
    avatar: '夜',
    rating: 4,
    time: '2周前',
    content: '每天晚上躺床上用虫虫动漫看漫画已经成为习惯了。下拉式阅读体验很沉浸，屏幕亮度夜间模式也很护眼。希望能再多一些评论互动功能，想和其他读者一起讨论剧情！',
    tag: '活跃用户',
  },
  {
    name: '新入坑小白',
    avatar: '新',
    rating: 5,
    time: '3周前',
    content: '最近才开始看漫画，朋友推荐了虫虫动漫。分类很清晰，新人也能快速找到感兴趣的题材。从热血番入坑，现在已经沉迷异世界了哈哈。太适合我这种漫画新手了！',
    tag: '漫画新手',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            读者热评
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            百万读者的真实声音
          </p>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
            {comments.map((comment) => (
              <div
                key={comment.name}
                className="bg-background-100 rounded-xl p-5 border border-background-200/70"
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-sm shrink-0">
                    {comment.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                        {comment.tag}
                      </span>
                    </div>
                    <div className="flex items-center gap-0.5 mt-1">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-background-300'}`}
                        ></i>
                      ))}
                      <span className="text-xs text-foreground-400 ml-2">{comment.time}</span>
                    </div>
                    <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                      {comment.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}